import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Heart, Copy, Check, Send } from 'lucide-react';

export const ReferralSection = ({ 
  referralStats, 
  onCopyCode, 
  copySuccess, 
  inviteEmail,
  setInviteEmail,
  onSendInvite,
  sendingInvite
}) => {
  return (
    <div className="bg-white/60 backdrop-blur-md border border-[#EAE4DC] shadow-lg rounded-2xl p-8">
      <div className="flex items-center space-x-3 mb-6">
        <Heart className="w-6 h-6 text-stone-600" strokeWidth={1.5} />
        <h2
          className="text-2xl font-medium"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Share the Healing
        </h2>
      </div>
      
      <p className="text-stone-600 mb-6">
        Give a friend 21 days free. When they subscribe, you both get 7 bonus days.
      </p>
      
      {referralStats && (
        <div className="space-y-4">
          {/* Referral Code */}
          <div className="flex gap-2">
            <div 
              className="flex-1 p-3 rounded-lg font-mono text-lg tracking-wider"
              style={{ backgroundColor: 'rgba(201,168,76,0.1)' }}
            >
              {referralStats.referral_code}
            </div>
            <Button
              onClick={onCopyCode}
              variant="outline"
              className="rounded-lg px-4"
              data-testid="copy-referral-code"
            >
              {copySuccess ? <Check className="w-4 h-4 text-green-600" /> : <Copy className="w-4 h-4" />}
            </Button>
          </div>
          
          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 py-4">
            <div className="text-center">
              <div className="text-2xl font-medium" style={{ color: '#C9A84C' }}>
                {referralStats.referrals_sent || 0}
              </div>
              <div className="text-xs text-stone-500">Invited</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-medium" style={{ color: '#C9A84C' }}>
                {referralStats.referrals_converted || 0}
              </div>
              <div className="text-xs text-stone-500">Joined</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-medium" style={{ color: '#C9A84C' }}>
                {referralStats.free_days_earned || 0}
              </div>
              <div className="text-xs text-stone-500">Days Earned</div>
            </div>
          </div>
          
          {/* Send Invite */}
          <div className="pt-4 border-t border-stone-200">
            <label className="text-sm text-stone-600 mb-2 block">
              Send an invite email
            </label>
            <div className="flex gap-2">
              <Input
                type="email"
                placeholder="friend@email.com"
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
                className="flex-1"
                data-testid="invite-email-input"
              />
              <Button
                onClick={onSendInvite}
                disabled={sendingInvite || !inviteEmail}
                className="rounded-lg px-4 text-[#1A1A2E]"
                style={{ backgroundColor: '#C9A84C' }}
                data-testid="send-invite-button"
              >
                {sendingInvite ? '...' : <Send className="w-4 h-4" />}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
